var _excluded = ["__stylingLibInternal_type", "__stylingLibInternal_validationContext"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from "react";
import * as React from "react";
import { Portal } from "../../components/Portal";
import Dock from "react-dock";
import { theme } from "../../components/theme";
import { Action, Title, DetailAction, DetailText, Subheading, BodyText } from "../../components/Text";
import { RAW_cssValue } from "../RAW_cssValue";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { Fragment as _Fragment } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
export var ValidationCollector = /*#__PURE__*/React.forwardRef(function ValidationCollector(_ref, ref) {
  var type = _ref.__stylingLibInternal_type,
    validationContext = _ref.__stylingLibInternal_validationContext,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1]; // Wait until children mounts so that we can collect the errors

  React.useEffect(function () {
    setErrors(validationContext.errors);
  }, [validationContext.errors]);
  var WrappedComponent = type;
  var el = _jsx(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  if (errors.length > 0) {
    return _jsx(ValidationErrorPanel, {
      el: el,
      location: validationContext.location,
      validationErrors: errors
    });
  }
  return el;
});
var ValidationErrorPanel = function ValidationErrorPanel(_ref2) {
  var location = _ref2.location,
    validationErrors = _ref2.validationErrors,
    el = _ref2.el;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  if (validationErrors && validationErrors.length > 0) {
    return _jsxs(React.Fragment, {
      children: [_jsx(Portal, {
        children: _jsxs("div", {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          sx: {
            backgroundColor: "dt_watermelon50",
            cursor: "not-allowed",
            position: "relative"
          },
          children: [!expanded && _jsx(SeeMoreButton, {
            onClick: function onClick() {
              return setExpanded(true);
            }
          }), expanded && _jsx(Dock, {
            position: "right",
            fluid: true,
            isVisible: true,
            dimStyle: {
              opacity: 0.2
            },
            children: _jsxs("div", {
              sx: {
                padding: "dt_m",
                cursor: "auto",
                position: "relative"
              },
              children: [_jsx("div", {
                onClick: function onClick(e) {
                  e.stopPropagation();
                  setExpanded(false);
                },
                sx: {
                  cursor: "pointer",
                  display: "inline-block",
                  position: "relative"
                },
                children: _jsx(Action, {
                  children: "Close"
                })
              }), _jsxs("div", {
                children: [_jsx(Title, {
                  children: "'sx' theme validation error"
                }), _jsxs("div", {
                  sx: {
                    padding: "dt_s",
                    marginTop: "dt_s",
                    border: "dt_border_card",
                    borderRadius: "dt_radius_s",
                    boxShadow: "dt_shadow_shadezies"
                  },
                  children: [_jsxs(Action, {
                    compact: true,
                    kind: "inactive",
                    children: [_jsx("span", {
                      "aria-hidden": true,
                      children: "\uD83D\uDC49"
                    }), "Check", _jsx("a", {
                      style: {
                        color: "#4975F6"
                      },
                      href: "https://components.classdojo.com/?path=/docs/nessie-tokens--palette#palette-tokens",
                      target: "_blank",
                      children: "this"
                    }), " ", "for a full list of tokens"]
                  }), _jsx("div", {
                    sx: {
                      marginTop: "dt_xs"
                    }
                  }), _jsxs(Action, {
                    compact: true,
                    kind: "inactive",
                    children: [_jsx("span", {
                      "aria-hidden": true,
                      children: "\uD83D\uDC49"
                    }), "Check", _jsx("a", {
                      style: {
                        color: "#4975F6"
                      },
                      href: "https://components.classdojo.com/?path=/docs/nessie-guidelines-and-examples-how-tos--skip-design-tokens-validation#skip-design-tokens-validation",
                      target: "_blank",
                      children: "this"
                    }), " ", "for more info on when & how to skip tokens validation"]
                  }), _jsx("div", {
                    sx: {
                      marginTop: "dt_xs"
                    }
                  }), _jsxs(Action, {
                    compact: true,
                    kind: "inactive",
                    children: [_jsx("span", {
                      "aria-hidden": true,
                      children: "\uD83D\uDC49"
                    }), "Check", _jsx("a", {
                      style: {
                        color: "#4975F6"
                      },
                      href: "https://components.classdojo.com/?path=/docs/nessie-start-here--page",
                      target: "_blank",
                      children: "this"
                    }), " ", "for more documentation about styling and nessie"]
                  })]
                }), _jsx("div", {
                  sx: {
                    marginBottom: "dt_m"
                  }
                }), validationErrors.map(function (validationError, index) {
                  return _jsxs("div", {
                    children: [_jsx(ErrorMessage, _objectSpread(_objectSpread({}, validationError), {}, {
                      location: location
                    })), _jsx("div", {
                      sx: {
                        border: "dt_border_card",
                        width: "100%",
                        marginTop: "dt_s",
                        marginBottom: "dt_s"
                      }
                    })]
                  }, index);
                })]
              })]
            })
          })]
        })
      }), /*#__PURE__*/React.cloneElement(el, {
        style: _objectSpread(_objectSpread({}, el.props.style), {}, {
          outline: "4px dotted red"
        })
      })]
    });
  }
  return el;
};
var SeeMoreButton = function SeeMoreButton(_ref3) {
  var _onClick = _ref3.onClick;
  return _jsx("div", {
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick();
    },
    sx: {
      backgroundColor: "dt_watermelon50",
      border: "dt_border_card",
      borderRadius: "dt_radius_s",
      color: "dt_white",
      cursor: "pointer",
      zIndex: "9999",
      position: "fixed",
      top: "10px",
      left: "10px",
      paddingLeft: "dt_l",
      paddingRight: "dt_l",
      paddingTop: "dt_xs",
      paddingBottom: "dt_xs"
    },
    children: "See more"
  });
};
var ErrorMessage = function ErrorMessage(props) {
  var optionsContent = null;
  var title = null;
  if ("colors" === props.scale) {
    optionsContent = _jsx(ColorOptions, {
      colors: props.options
    });
    title = _jsxs(_Fragment, {
      children: ["You are trying to use a color value that doesn't exist in the theme\xA0'", _jsx(DetailText, {
        sx: {
          color: "dt_watermelon50"
        },
        children: props.cssPropValue
      }), "'"]
    });
  } else if ("space" === props.scale) {
    optionsContent = _jsx(SpacingOptions, {
      spacingTokens: props.options
    });
    title = _jsxs(_Fragment, {
      children: ["You are trying to use a spacing value that doesn't exist in the theme\xA0'", _jsx(DetailText, {
        sx: {
          color: "dt_watermelon50"
        },
        children: props.cssPropValue
      }), "'"]
    });
  } else {
    optionsContent = (props.options || []).map(function (option) {
      return _jsx("div", {
        children: option
      }, option);
    });
    title = _jsxs(_Fragment, {
      children: ["Theme value not found\xA0'", _jsx(DetailText, {
        sx: {
          color: "dt_watermelon50"
        },
        children: props.cssPropValue
      }), "'"]
    });
  }
  return _jsxs("div", {
    children: [_jsx(Subheading, {
      children: title
    }), _jsx("div", {
      sx: {
        marginTop: "s"
      }
    }), _jsxs("div", {
      children: ["Component: ", _jsx(DetailAction, {
        inline: true,
        children: props.location
      })]
    }), _jsxs("div", {
      children: ["Css prop: ", _jsx(DetailAction, {
        inline: true,
        children: props.cssPropName
      })]
    }), _jsxs("div", {
      children: ["Css value found: ", _jsx(DetailAction, {
        inline: true,
        children: props.cssPropValue
      })]
    }), _jsx("div", {
      sx: {
        marginTop: "dt_m"
      }
    }), _jsxs("div", {
      children: [_jsx(BodyText, {
        sx: {
          marginBottom: "dt_s"
        },
        children: "Available tokens"
      }), optionsContent]
    })]
  });
}; //
// Scales options
//

var SpacingOptions = function SpacingOptions(props) {
  return _jsx("div", {
    children: props.spacingTokens.map(function (spaceToken) {
      return _jsxs("div", {
        sx: {
          display: "flex",
          flexDirection: "column",
          padding: "dt_xs"
        },
        children: [_jsx("div", {
          sx: {
            width: theme.space[spaceToken],
            backgroundColor: "dt_watermelon40",
            borderColor: "dt_taro20",
            height: "10px"
          }
        }), _jsx("div", {
          children: spaceToken
        })]
      }, spaceToken);
    })
  });
};
var ColorOptions = function ColorOptions(props) {
  return _jsx("div", {
    sx: {
      display: "flex",
      flexWrap: "wrap"
    },
    children: props.colors.map(function (color) {
      return _jsxs("div", {
        sx: {
          display: "flex",
          width: "120px",
          height: "60px",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "dt_xs"
        },
        children: [_jsx("div", {
          sx: {
            backgroundColor: color,
            border: "1px solid",
            borderColor: "dt_taro20",
            width: "30px",
            height: "30px",
            borderRadius: RAW_cssValue("50%")
          }
        }), _jsx("div", {
          children: color
        })]
      }, color);
    })
  });
};